module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0080.jpg?v=aff14bfc";